// extracted by mini-css-extract-plugin
module.exports = {"scrollBtn":"ScrollToTop_scrollBtn__tQeoc","arrow":"ScrollToTop_arrow__UMweR","scrollTop":"ScrollToTop_scrollTop__zHg2W"};